function actionEntryMatchesName(entry: Record<string, unknown>, elementName: string): boolean {
  const name = String(elementName).trim()
  if (!name) return false
  const direct = String((entry as { name?: unknown }).name ?? '').trim()
  if (direct === name) return true
  const fromData = String(
    (entry as { data?: { name?: { _text?: unknown } } }).data?.name?._text ?? '',
  ).trim()
  return fromData === name
}

/** Ключи реестра actions — число из XML; states с сервера могут отдавать id строкой. */
export function resolveActionRegistryEntry(
  registry: Record<string, unknown> | null | undefined,
  elementId: unknown,
  elementName?: unknown,
): Record<string, unknown> | undefined {
  if (!registry) {
    return undefined
  }
  if (elementId != null && elementId !== '') {
    const direct = registry[elementId as string | number]
    if (direct && typeof direct === 'object') {
      return direct as Record<string, unknown>
    }
    const sid = String(elementId).trim()
    if (sid) {
      for (const key of Object.keys(registry)) {
        if (String(key).trim() === sid) {
          const entry = registry[key]
          if (entry && typeof entry === 'object') {
            return entry as Record<string, unknown>
          }
        }
      }
    }
  }
  const name = String(elementName ?? '').trim()
  if (!name) return undefined
  for (const entry of Object.values(registry)) {
    if (entry && typeof entry === 'object' && actionEntryMatchesName(entry as Record<string, unknown>, name)) {
      return entry as Record<string, unknown>
    }
  }
  return undefined
}

export function actionIdsEqual(a: unknown, b: unknown): boolean {
  if (a == null || b == null) return false
  return String(a).trim() === String(b).trim()
}
